import '../../resources/css/visual/VisualMonitor.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { filterOrgAction, filterGroupAction } from '../../actions/model/index';
import VisualBlueprint from './VisualBlueprint';
import {
    getVisualGroupRSSIAction,
    doDisplayBlueprint,
    DELETE_VISUAL_DATA_SUCCESS,
    doSelectFloorPlanProject,
    doGetFloorPlanProjectList,
    filterFloorPlan,
    doGetVisualDataId, doGetFloorDetail, resetFloorData,
} from '../../actions/visual/index';
// import Ruler from '../../components/common/Ruler';
// import SelectQuickDevice from '../frame/SelectQuickDevice';
// import SelectQuickOrganization from '../frame/SelectQuickOrganization';
import RFMap from '../../resources/img/img-rf-map.png';
import { Button } from 'react-bootstrap';
import { doActivePage } from '../../actions/menu/index';
import { dispathVisualMangerDetail, SAVE_VISUAL_MANAGER_DETAIL, doGetVisualData } from '../../actions/visual/index';
import { openModal, closeModal, popupModalConfirm, openModalTip, openModalAlert } from '../../actions/index';
import ModalVisualManagerDetail from './ModalVisualManagerDetail';
import Loading from "../common/Loading";
// import { Modal } from 'react-bootstrap';
// import SelectQuickDevice from '../frame/SelectQuickDevice';
// import SelectQuickOrganization from '../frame/SelectQuickOrganization';


// let componentProps = null;
//refTabulatorTable = null;

// const GroupBtnsMenu = (props) => {
//     const cellData = props.cell._cell.row.data;
//     return (
//         <div className='group-buttons-menu'>
//             <span className='operation-button-area'>
//               <span className='btn-area'><span className='icon-settings' onClick={() => settingList(cellData)}/></span>
//             </span>
//             {/* <span className='more-button-area'>
//               <span className='btn-area'><span className='icon-btn-more-dark'/></span>
//             </span> */}
//         </div>
//     );
//   };

//   const settingList = (cellData) => {
//     if (componentProps) {
//       const { openModal, dispathVisualMangerDetail } = componentProps;
//       openModal("visual/manager", 'setting', null, () => dispathVisualMangerDetail(cellData));
//     }  
//   }

// let orgFilter;
class VisualMonitor extends Component {

    constructor(props) {
        super(props)
        this.state = {
        }
    }



    componentDidMount() {
        const { doSelectFloorPlanProject  } = this.props;        
        doSelectFloorPlanProject(localStorage.getItem("projectSeq"), localStorage.getItem("environment"), localStorage.getItem("address"));
        // doGetVisualData(authToken, localStorage.getItem("projectSeq"));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            authToken,
            selectFloorPlanProject,
            selectGraph,
            getVisualGroupRSSIAction,
            status,
            openModalAlert,
            history,
            activePage,
            doGetVisualDataId,
            visualListId,
            doGetFloorDetail,
            resetFloorData,
            floorPlanData
        } = this.props

        if (prevProps.selectGraph !== selectGraph && visualListId) {
            const selectFloorPlan = selectGraph
            doGetFloorDetail(authToken, selectFloorPlan)
        }

        
        if (prevProps.selectFloorPlanProject !== selectFloorPlanProject && selectFloorPlanProject) {
            const selectedProjectId = selectFloorPlanProject;
            if(selectedProjectId !== "null"){
                // resetFloorPlanDetail()
                resetFloorData()
                doGetVisualDataId(authToken, selectedProjectId);
                // doGetVisualData(authToken,  selectFloorPlanProject);
            } else {
                openModalAlert("Please add a project first.");
                history.push(window.CONFIG.WEB_ROOT + "/rf_map/project");
            }
        }

        if (prevProps.floorPlanData !== floorPlanData && floorPlanData) {
            getVisualGroupRSSIAction(
                floorPlanData.rssiInfo,
                floorPlanData.orgId,
                floorPlanData.id,
                floorPlanData.interiorGraph,
                floorPlanData.wallInfo
            )
        }

        if (prevProps.status !== status && (status === SAVE_VISUAL_MANAGER_DETAIL || status === DELETE_VISUAL_DATA_SUCCESS)) {
            doGetVisualDataId(authToken, selectFloorPlanProject);
        }
        if(prevProps.activePage !== activePage && (visualListId?.mappingGroups.length === 0 || visualListId === null)) {
            history.push(window.CONFIG.WEB_ROOT + '/' + activePage);
        }

    }

    componentWillUnmount() {
        localStorage.removeItem("graphId")
    }

    render() {
        // const {  } = componentProps;
        const { tabulatorDivHeight, openModal, dispathVisualMangerDetail, selectGraph, visualListId, isLoadingProject } = this.props;
        let pageContent;

        if (visualListId == null && !isLoadingProject) {
            pageContent = (<div className='area-initial-body'>
                <img src={RFMap} alt='RF Map'/>
                <div className='area-initial-title'>Radio Frequency(RF) Map</div>
                <div className='area-initial-description'>The radio frequency (RF) map enables you to view AP Coverage
                    for a location floor. You can import the floor layout and place APs on the floor map to understand
                    the boundaries of RF coverage with different threshold values. Then, it can help you find out the
                    best plan to place all of Wi-Fi APs.
                </div>
                <div style={{margin: '0 auto', display: 'block'}}><Button bsPrefix='btn add-rf-map-btn'
                                                                          onClick={() => openModal("visualMangerImportPDF", 'add-multi-floor', null, () => dispathVisualMangerDetail(null))}>Add
                    Floor Plan</Button></div>
                {/* <div style={{ margin: '0 auto', display: 'block' }}><Button bsPrefix='btn add-rf-map-btn' onClick={() => openModalTip("RF Map coming soon", "Coming Soon")}>Add RF Map</Button></div> */}
            </div>);
        } else {
            if (visualListId && !isLoadingProject) {
                pageContent = (
                    <>
                        <div className='area-interior-blueprint'
                             style={selectGraph ? {display: 'grid'} : {display: 'none'}}>
                            <VisualBlueprint></VisualBlueprint>
                        </div>
                    </>
                );
            } else {
                pageContent = (<Loading loading={true}></Loading>)
            }
        }

        return (
            <div className='area-visual-monitor' style={{ height: tabulatorDivHeight }}>
                {pageContent}
                <ModalVisualManagerDetail  mappingGroups={visualListId?.mappingGroups}></ModalVisualManagerDetail>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        authToken: state.loginReducers.authToken,
        accountRole: state.loginReducers.accountRole,
        selectOrg: state.siteReducers.selectSite,
        displayBlueprint: state.visualReducers.displayBlueprint,
        mappingInteriorGraph: state.visualReducers.mappingInteriorGraph,
        status: state.visualReducers.status,
        interiorGraphImgUrl: state.visualReducers.interiorGraphImgUrl,
        visualList: state.visualReducers.visualList,
        selectGraph: state.visualReducers.graphId,
        selectGraphValue: state.visualReducers.graphValue,
        selectFloorPlanProject: state.visualReducers.selectFloorPlanProject,
        floorPlanProjectList: state.visualReducers.floorPlanProjectList,
        activePage: state.menuReducers.activePage,
        floorPlan: state.visualReducers.floorPlan,
        visualListId: state.visualReducers.visualListId,
        isLoadingProject: state.visualReducers.isLoadingProject,
        isLoadingFloorData: state.visualReducers.isLoadingFloorData,
        virtualDeviceInfo: state.visualReducers.virtualDeviceInfo,
        floorPlanData: state.visualReducers.floorPlanData,
    }
}



export default withRouter(connect(
    mapStateToProps,
    {
        doDisplayBlueprint,
        getVisualGroupRSSIAction,
        filterOrgAction,
        filterGroupAction,
        doActivePage,
        dispathVisualMangerDetail,
        openModal,
        closeModal,
        popupModalConfirm,
        openModalTip,
        doGetFloorDetail,
        doGetVisualData,
        doGetVisualDataId,
        doSelectFloorPlanProject,
        doGetFloorPlanProjectList,
        filterFloorPlan,
        openModalAlert,
        resetFloorData
    }
)(VisualMonitor));